import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from "@tanstack/react-query";

export const AUTH_ME_QUERY_KEY = ["auth", "me"] as const;

export interface AuthMeUser {
  sub: string;
  email: string;
  groups: string[];
  branch_id?: string | null;
  user_id?: string | null;
  role?: string | null;
}

async function fetchAuthMe(): Promise<AuthMeUser> {
  const res = await fetch("/api/auth/me", { credentials: "include" });
  if (res.status === 401) throw new Error("unauthorized");
  if (!res.ok) throw new Error(`http_${res.status}`);
  return res.json();
}

export const authMeQueryOptions = {
  queryKey: AUTH_ME_QUERY_KEY,
  queryFn: fetchAuthMe,
  retry: false,
  staleTime: 60_000,
} satisfies Omit<UseQueryOptions<AuthMeUser, Error>, "enabled">;

export function useAuthMe(
  options?: Omit<UseQueryOptions<AuthMeUser, Error>, "queryKey" | "queryFn">,
): UseQueryResult<AuthMeUser, Error> {
  return useQuery<AuthMeUser, Error>({
    ...authMeQueryOptions,
    ...options,
  });
}
